<div class="bg-gray-50 dark:bg-gray-800/50 rounded-2xl p-6 border border-gray-100 dark:border-gray-700">
    
    <mat-form-field subscriptSizing="dynamic" class="w-full">
        <mat-label>Adres e-mail</mat-label>
        <mat-icon matPrefix [svgIcon]="'tabler_outline:mail'" class="text-gray-400 mr-2"></mat-icon>
        <input type="email" matInput lowercaseEmail [formControl]="registerForm.controls.emailAddress" placeholder="jan.kowalski@firma.pl">
        <mat-error *ngIf="registerForm.controls.emailAddress.touched && registerForm.controls.emailAddress?.errors?.['invalidEmail']">
            Nieprawidłowy format adresu e-mail
        </mat-error>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic" class="w-full mt-2">
        <mat-label>Powtórz adres e-mail</mat-label>
        <mat-icon matPrefix [svgIcon]="'tabler_outline:mail-check'" class="text-gray-400 mr-2"></mat-icon>
        <input type="email" matInput lowercaseEmail [formControl]="registerForm.controls.emailAddressRepeat" placeholder="jan.kowalski@firma.pl">
        <mat-error *ngIf="registerForm.hasError('matchFields')">
            Adresy e-mail muszą być identyczne
        </mat-error>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic" class="w-full mt-2">
        <mat-label>Hasło</mat-label>
        <mat-icon matPrefix [svgIcon]="'tabler_outline:lock'" class="text-gray-400 mr-2"></mat-icon>
        <input [type]="showPassword ? 'text' : 'password'" matInput [formControl]="registerForm.controls.password" placeholder="Minimum 8 znaków">
        <button mat-icon-button matSuffix (click)="showPassword = !showPassword" type="button">
            <mat-icon [svgIcon]="showPassword ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"></mat-icon>
        </button>
        <mat-error *ngIf="registerForm.controls.password.touched && registerForm.controls.password.errors?.['minlength']">
            Hasło musi mieć minimum 8 znaków
        </mat-error>
    </mat-form-field>

    <!-- Checkbox regulaminu -->
    <div class="mt-4 p-4 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-600">
        <mat-checkbox color="primary" [formControl]="registerForm.controls.rules" class="text-sm">
            <span class="text-gray-700 dark:text-gray-300">
                Akceptuję 
                <a href="https://fakturnia.pl/regulamin" target="_blank" class="text-primary-600 hover:text-primary-700 dark:text-primary-400 font-medium">regulamin</a> 
                oraz 
                <a href="https://fakturnia.pl/polityka-prywatnosci" target="_blank" class="text-primary-600 hover:text-primary-700 dark:text-primary-400 font-medium">politykę prywatności</a>
            </span>
        </mat-checkbox>
        <p *ngIf="registerForm.controls.rules.touched && registerForm.controls.rules?.errors?.['required']" 
           class="text-red-500 text-xs mt-2 flex items-center gap-1">
            <mat-icon [svgIcon]="'tabler_outline:alert-circle'" class="!w-4 !h-4"></mat-icon>
            Wymagana akceptacja regulaminu
        </p>
    </div>

    <button mat-flat-button color="primary" [disabled]="isProcessing" class="w-full h-12 text-base mt-6" (click)="register()">
        <mat-icon *ngIf="isProcessing" class="icn-spinner mr-2" [svgIcon]="'tabler_outline:loader'"></mat-icon>
        <span *ngIf="!isProcessing" class="flex items-center justify-center gap-2">
            <span>Utwórz konto</span>
            <mat-icon [svgIcon]="'tabler_outline:arrow-right'" class="!w-5 !h-5"></mat-icon>
        </span>
        <span *ngIf="isProcessing">Tworzenie konta...</span>
    </button>
</div>
